"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactFlowBase = void 0;
var react_1 = __importStar(require("react"));
var react_flow_renderer_1 = __importStar(require("react-flow-renderer"));
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var Controls_1 = require("./components/Controls");
require("./styles/react-flow-base.scss");
/**
 * ReactFlowBase - Base wrapper component for React Flow
 */
var ReactFlowBaseContent = function (_a) {
    var elements = _a.elements, onConnect = _a.onConnect, nodeTypes = _a.nodeTypes, edgeTypes = _a.edgeTypes, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, _c = _a.showControls, showControls = _c === void 0 ? true : _c, _d = _a.showMinimap, showMinimap = _d === void 0 ? false : _d, _e = _a.className, className = _e === void 0 ? "" : _e, _f = _a.isLoading, isLoading = _f === void 0 ? false : _f, _g = _a.fitViewOnMount, fitViewOnMount = _g === void 0 ? true : _g, _h = _a.autoFitOnChange, autoFitOnChange = _h === void 0 ? true : _h, _j = _a.fitViewTrigger, fitViewTrigger = _j === void 0 ? null : _j;
    var reactFlowWrapper = react_1.useRef(null);
    var _k = react_1.useState(false), isFullscreen = _k[0], setIsFullscreen = _k[1];
    var fitView = react_flow_renderer_1.useReactFlow().fitView;
    var previousNodeCountRef = react_1.useRef(0);
    var previousFitViewTriggerRef = react_1.useRef(fitViewTrigger);
    var handleFitView = react_1.useCallback(function () {
        fitView({ padding: 0.2 });
    }, [fitView]);
    var handleToggleFullscreen = react_1.useCallback(function () {
        var _a;
        if (!document.fullscreenElement) {
            (_a = reactFlowWrapper.current) === null || _a === void 0 ? void 0 : _a.requestFullscreen();
            setIsFullscreen(true);
        }
        else {
            document.exitFullscreen();
            setIsFullscreen(false);
        }
    }, []);
    var handleScreenshot = react_1.useCallback(function () {
        var _a;
        var element = (_a = reactFlowWrapper.current) === null || _a === void 0 ? void 0 : _a.querySelector(".react-flow");
        if (!element)
            return;
        Promise.resolve().then(function () { return __importStar(require("html-to-image")); }).then(function (_a) {
            var toPng = _a.toPng;
            toPng(element, {
                backgroundColor: "#ffffff",
                width: element.offsetWidth,
                height: element.offsetHeight,
                style: {
                    transform: "scale(1)",
                    transformOrigin: "top left",
                },
                filter: function (node) {
                    var excludeClasses = [
                        "react-flow__minimap",
                        "react-flow__controls",
                    ];
                    return !excludeClasses.some(function (cls) { var _a; return (_a = node.classList) === null || _a === void 0 ? void 0 : _a.contains(cls); });
                },
            })
                .then(function (dataUrl) {
                var link = document.createElement("a");
                link.download = "strategy-flow-" + Date.now() + ".png";
                link.href = dataUrl;
                link.click();
            })
                .catch(function (error) {
                console.error("Failed to generate screenshot:", error);
            });
        })
            .catch(function (error) {
            console.error("Failed to load html-to-image:", error);
        });
    }, []);
    react_1.default.useEffect(function () {
        if (!autoFitOnChange)
            return;
        var currentNodeCount = elements.filter(function (el) { return !("source" in el); }).length;
        if (currentNodeCount > 0 &&
            currentNodeCount !== previousNodeCountRef.current) {
            previousNodeCountRef.current = currentNodeCount;
            setTimeout(function () {
                handleFitView();
            }, 300);
        }
    }, [elements, handleFitView, autoFitOnChange]);
    react_1.default.useEffect(function () {
        var currentNodeCount = elements.filter(function (el) { return !("source" in el); }).length;
        if (!isLoading && currentNodeCount > 0) {
            setTimeout(function () {
                handleFitView();
            }, 150);
        }
    }, [isLoading, elements.length, handleFitView]);
    react_1.default.useEffect(function () {
        var currentNodeCount = elements.filter(function (el) { return !("source" in el); }).length;
        if (previousFitViewTriggerRef.current === fitViewTrigger ||
            isLoading ||
            currentNodeCount === 0) {
            previousFitViewTriggerRef.current = fitViewTrigger;
            return;
        }
        previousFitViewTriggerRef.current = fitViewTrigger;
        setTimeout(function () {
            handleFitView();
        }, 150);
    }, [fitViewTrigger, isLoading, elements, handleFitView]);
    var handleInit = react_1.useCallback(function () {
        if (fitViewOnMount) {
            setTimeout(function () {
                handleFitView();
            }, 100);
        }
    }, [handleFitView, fitViewOnMount]);
    react_1.default.useEffect(function () {
        var handleFullscreenChange = function () {
            var isCurrentlyFullscreen = !!document.fullscreenElement;
            setIsFullscreen(isCurrentlyFullscreen);
            setTimeout(function () {
                handleFitView();
            }, 100);
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return function () {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, [handleFitView]);
    return (react_1.default.createElement("div", { ref: reactFlowWrapper, className: "react-flow-base-wrapper " + className + " " + (isFullscreen ? "fullscreen" : "") },
        isLoading && (react_1.default.createElement("div", { className: "react-flow-loading-overlay" },
            react_1.default.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.large, label: "Loading visualization..." }))),
        showControls && (react_1.default.createElement(Controls_1.ReactFlowControls, { onFitView: handleFitView, onToggleFullscreen: handleToggleFullscreen, onScreenshot: handleScreenshot, isFullscreen: isFullscreen })),
        react_1.default.createElement(react_flow_renderer_1.default, { nodes: elements.filter(function (el) { return !("source" in el); }), edges: elements.filter(function (el) { return "source" in el; }), nodeTypes: nodeTypes, edgeTypes: edgeTypes, onConnect: readOnly ? undefined : onConnect, onInit: handleInit, nodesDraggable: !readOnly, nodesConnectable: !readOnly, elementsSelectable: true, snapToGrid: true, snapGrid: [15, 15], minZoom: 0.1, maxZoom: 4, defaultZoom: 1, fitView: true },
            react_1.default.createElement(react_flow_renderer_1.Background, { color: "#aaa", gap: 16 }),
            showMinimap && react_1.default.createElement(react_flow_renderer_1.MiniMap, null))));
};
/**
 * ReactFlowBase with Provider wrapper
 */
exports.ReactFlowBase = function (props) {
    return (react_1.default.createElement(react_flow_renderer_1.ReactFlowProvider, null,
        react_1.default.createElement(ReactFlowBaseContent, __assign({}, props))));
};
